import { isDefined } from '@sgme/fp';
import { FieldMetadataContext } from 'components/common-form/contexts/FieldMetadataContext';
import { useContext } from 'react';

export function useHasFieldMetadata(fieldId: string): boolean {
  const metadataById = useContext(FieldMetadataContext);
  return isDefined(metadataById[fieldId]);
}
